/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, AuthStoreService } from '../../../../core/services';
import { ErrorResponseModel } from '../../../../core/models';
import { Injectable } from '@angular/core';
import { ModulesEnum } from '../../../../core/enums';
import { Observable } from 'rxjs';
import { SyslogEnum } from '../enums/api';

@Injectable()
export class ViewLogsApiService {
    constructor(
        private apiService: ApiService,
        private authStoreService: AuthStoreService
    ) {
    }

    /**
     * Get list of available services.
     * @param options
     */
    public getServices(options?: any): Observable<any> {
        return new Observable<any>((observer) => {
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);
            this.apiService.get(
                SyslogEnum.GET_SERVICES(),
                moduleAuth,
                true
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * The API call to get the log data.
     * @returns {any}
     */
    public getLogData(logOptions: any, apiOptions?: any): Observable<any> {
        const logData = {
            'services': logOptions.services,
            'lines': logOptions.lines,
            'since': logOptions.start,
            'until': logOptions.end,
            'reverse': logOptions.reverse
        };

        return new Observable((observer) => {
            // Get our selected module details
            const moduleAuth = logOptions?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);
            this.apiService.get(
                SyslogEnum.GET_LOG(logData.services, logData.since, logData.until, logData.reverse, logData.lines),
                moduleAuth,
                true,
                apiOptions
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }

    /**
     * Get all logs.
     * @param lines
     * @param options
     */
    public getAllLogs(lines = '1000', options?: any): Observable<any> {
        return new Observable(observer => {
            const moduleAuth = options?.auth || this.authStoreService.getSelectedModuleAuth(ModulesEnum.LOADBALANCER);
            this.apiService.get(
                SyslogEnum.GET_ALL_LOGS(lines),
                moduleAuth,
                true,
                options
            ).subscribe(
                (data: any) => {
                    observer.next(data);
                    observer.complete();
                },
                (error: ErrorResponseModel) => {
                    observer.error(error);
                    observer.complete();
                }
            );
        });
    }
}
